
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface ICheckoutLoyaltyTextProps {
    className: string;
    text?: string;
}

/**
 *
 * AddPaymentForm SFC
 * @extends {React.FC<ICheckoutLoyaltyTextProps>}
 */
const CheckoutLoyaltyText: React.FC<ICheckoutLoyaltyTextProps> = ({
    className,
    text,
}) => {
    if(!text) {
        return null;
    }

    return <span className={className}>{text}</span>;
};

export default CheckoutLoyaltyText;